import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Button } from '@mui/material'

export type AddNewInvestmentProps = ExtendableStyles &
  Testable & {
    onCreate: () => void
  }

export function AddNewInvestment({ className, onCreate, ...otherProps }: AddNewInvestmentProps) {
  const { classes, cx } = useStyles()
  return (
    <Button
      color="secondary"
      variant="contained"
      className={cx(classes.button, className)}
      onClick={onCreate}
      {...otherProps}
    >
      Add new investment
    </Button>
  )
}

const useStyles = makeStyles()({
  button: {
    position: 'relative',
  },
})
